import { NgStyle } from '@angular/common'
import { Component, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faCamera, faVideo, faX } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import imageCompression, { Options } from 'browser-image-compression'

import { EquipmentBreakdown, ListItem, RepositoryModal } from '../../shared'
import { AvailabilityComponent } from './availability.component'

@Component({
    templateUrl: './breakdown.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent, NgStyle],
})
export class BreakdownComponent extends RepositoryModal<EquipmentBreakdown> {
    faCamera = faCamera
    faVideo = faVideo
    faX = faX

    equipmentMap: ListItem<string>[] = []
    @ViewChild('videoInput') videoInputRef!: HTMLInputElement
    videoElement!: HTMLVideoElement
    stream!: MediaStream
    images: any[] = []
    videos: any[] = []
    progress = 0
    previewSrc = ''
    mechanicMap: ListItem<number>[] = []

    protected onInitialized() {
        const availabilityComponent = this.editOptions.initializeParams as AvailabilityComponent
        this.equipmentMap = availabilityComponent.grid.items.map(x => new ListItem(x.equipment, x.description))
        this.mechanicMap = availabilityComponent.activeUserMap.collectionView.items.map(x => new ListItem(x.id, x.name))
    }

    async onFileChanged(event) {
        // When the user picks images, we will compress and store them locally.
        // They will get uploaded after the item is saved.
        const files = event.target.files
        const progress = (p: number) => {
            this.progress = p
        }
        for (const file of files) {
            const options: Options = {
                maxSizeMB: 2,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
                onProgress: progress,
            }
            const compressedFile = await imageCompression(file, options)
            compressedFile['url'] = await imageCompression.getDataUrlFromFile(compressedFile)
            this.images.push(compressedFile)
        }
    }

    async onFileChangedVideo(event) {
        // When the user picks videos, we will them locally.
        // They will get uploaded after the item is saved.
        const files = event.target.files
        for (const video of files) {
            const reader = new FileReader()

            reader.onload = e => {
                const dataURL = e.target?.result as string
                this.previewSrc = dataURL
                video.previewSrc = dataURL
            }

            reader.readAsDataURL(video)

            // this.previewSrc = URL.createObjectURL(video);
            this.videos.push(video)
        }
        this.videoInputRef.value = ''
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        const observable = this.isAdding || this.isDuplicating ? this.repositoryAdd() : this.repositoryEdit()
        observable.subscribe({
            next: result => {
                if (this.images.length === 0 && this.videos.length === 0) {
                    resolveSave(result)
                    return
                }

                // If the saving of the record is successful, we will upload any images and videos
                const uploadData = new FormData()
                uploadData.append('id', result.id)
                for (let i = 0; i < this.images.length; i++) {
                    uploadData.append('myFile' + i, this.images[i], this.images[i].name)
                }
                for (let i = 0; i < this.videos.length; i++) {
                    uploadData.append('myFile' + i, this.videos[i], this.videos[i].name)
                }
                this.services.data.post('api/EquipmentBreakdown/UploadImages', uploadData).subscribe({
                    next: uploadResult => {
                        resolveSave(uploadResult)
                    },
                    error: errorResult => {
                        rejectSave(errorResult)
                    },
                })
            },
            error: errorResult => {
                rejectSave(errorResult)
            },
        })
    }

    removeImage(image) {
        this.images.remove(image)
    }

    removeVideo(video) {
        console.log(video)
        this.videos.remove(video)
    }

    canShowImage(url) {
        return url.indexOf('mp4') === -1
    }

    canShowVideo(url) {
        return url.indexOf('mp4') > -1
    }
}
